import { Component, OnInit } from '@angular/core';
import { ChartDataset, ChartType, ChartOptions } from 'chart.js';
import { chartPalette } from '../../../_helpers/theming-engine/themes.const';

@Component({
    selector: 'radar-chart',
    templateUrl: './radar-chart.component.html',
    styleUrls: ['./radar-chart.component.css'],
    standalone: false
})
export class RadarChartComponent implements OnInit {

  public radarChartOptions: ChartOptions = {
    responsive: true,
  };
  public radarChartLabels: string[] = ['Punctuality', 'Communication', 'Problem Solving',
    'Team Player', 'Coding', 'Technical Knowledge', 'Meeting Deadlines'];

  public radarChartData: ChartDataset[] = [];
  public radarChartType: ChartType = 'radar';

  constructor() {
    this.radarChartData = [
      {
        data: [0, 1, 2, 3, 4, 5, 6],
        label: 'Employee Skill Analysis',
        borderColor: chartPalette['--primary'],
        backgroundColor: chartPalette['--primary-opaque-25'],
      },
    ];
  }

  ngOnInit() {
  }

}
